import SpinnerMedium from "components/Spinner/Medium"
import PageTitle from "components/Title/Page"
import React from "react"

const FileUploadingSpinner = () => {
    return (
        <div>
            <PageTitle>파일 업로드 중</PageTitle>
            <SpinnerMedium />
        </div>
    )
}

export default FileUploadingSpinner;